module.exports = __webpack_public_path__ + "img/underline.41bd1996.svg";